// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import get from "lodash/get"
let NoteListItemView
require("./styles/note-list-item.css")

const {
  renderMathInElement
} = require("lib/core/components/text/katex-auto-render")
const { responsifyKatex } = require("lib/core/components/text/utils")

export default NoteListItemView = (function () {
  NoteListItemView = class NoteListItemView extends (
    require("lib/static-shim").default(require("lib/core/item-view").default)
  ) {
    static initClass() {
      this.prototype.template = require("./templates/note-list-item.html")
      this.prototype.className = "note-list-item-view"
      this.prototype.tagName = "li"

      this.prototype.triggers = {
        "click .note-read-more": "show:note:body",
        "click #edit-note": "edit:note",
        "click #delete-note": "delete:note"
      }

      this.prototype.modelEvents = {
        destroy: "transitionDestroy",
        sync: "updated"
      }
    }

    initialize() {
      this.listenTo(Pathwright.vent, "collapse:notes", function () {
        return this.triggerMethod("show")
      })
      this.listenTo(Pathwright.vent, "expand:notes", function () {
        return this.triggerMethod("show:note:body")
      })
      this.listenTo(Pathwright.vent, "before:print:notes", function () {
        return this.renderKatex()
      })
    }

    renderKatex() {
      if (this.katexRendered) {
        return
      }
      this.katexRendered = true
      renderMathInElement(this.el, false)
      responsifyKatex(this.el)
    }

    // Probably not the best solution, but
    // transitioning the view out before destroying.
    // Not possible to use `onBeforeDestroy` for this
    // unless the Marionette.ItemView is modifed.
    transitionDestroy() {
      const { destroy } = this
      this.destroy = () => {
        this.transitionSlideOut()
        return setTimeout(() => {
          return this.transitionCollapse().then(() => {
            return destroy.call(this)
          })
        }, 150)
      }

      return this.destroy()
    }

    serializeData() {
      const data = super.serializeData()
      // If this note is for staff or everyone, then show school logo
      if (this.model.get("visibility") <= 10) {
        data.is_curriculum_wide_note = true
      }
      data.school_data = window.App.getStore("school").getState()
      data.perms = window.App.getStore("note").request.getNotePermissions(
        this.model
      )
      data.context = window.context
      data.shouldShowFullName = get(
        window.App.getStore("resource").request.permissions(),
        "can_facilitate",
        false
      )
      return data
    }

    updated() {
      this.render()
      return this.triggerMethod("show")
    }

    // Highlight note
    highlight() {
      if (this.model.get("highlight")) {
        this.model.unset("highlight")
        this.$el.addClass("highlighted")
        // Scroll to the note
        _.delay(() => {
          // Only scroll to note if note is inside the note panel
          if ($(".note-panel-view").length) {
            const offset =
              this.$el.offset().top -
              $(".note-panel-view").offset().top -
              this.$el.height()
            return $(".note-panel-view").animate({ scrollTop: offset }, 400)
          }
        }, 400)
        // Highlight the new note
        return _.delay(() => {
          return this.$el.removeClass("highlighted")
        }, 3000)
      }
    }

    onShow() {
      if (this.options.expanded) {
        return
      }
      // setInterval here because the view is not actually
      // in the DOM at this point
      return this.$(".note-body").waitForImages(() => {
        let handler
        return (handler = setInterval(() => {
          const h = this.$(".note-body").height()
          if (h > 0) {
            if (h >= 200) {
              this.$el.addClass("truncated")
            } else {
              this.renderKatex()
            }
            this.highlight()
            return clearInterval(handler)
          }
        }, 50))
      })
    }

    onShowNoteBody() {
      this.$el.removeClass("truncated")
      return this.renderKatex()
    }

    onEditNote() {
      this.$(".note-admin-menu").removeClass("open")
      return this.triggerMethod("show:note:form", this.model)
    }

    onDeleteNote() {
      this.$(".note-admin-menu").removeClass("open")
      const NoteListItemDeleteView = require("./note-list-item-delete").default
      const noteListItemDeleteView = new NoteListItemDeleteView({
        model: this.model
      })
      return this.$el.append(noteListItemDeleteView.render().el)
    }

    transitionSlideOut() {
      return $.Velocity.animate(this.$el, "transition.slideRightOut", {
        duration: 300
      })
    }

    transitionCollapse() {
      this.$el.css({
        height: this.$el.outerHeight(),
        padding: 0,
        display: "block"
      })

      this.$el.html("")

      return $.Velocity.animate(
        this.$el,
        { height: 0 },
        { duration: 300, easing: "easeOut", queue: false }
      )
    }
  }
  NoteListItemView.initClass()
  return NoteListItemView
})()
